import React from 'react';
import { Link } from 'react-router-dom';
import "../css/Footer.css";

function Footer() {
  // const footerColumns = [
  //   {
  //     title: "Services",
  //     links: [
  //       { name: "Form Builder", path: "/form-builder" },
  //       { name: "Template Builder", path: "/templatebuilder" },
  //       { name: "Marketing Analytics", path: "/marketing-analytics" },
  //       { name: "Email Tracking", path: "/email-tracking" }
  //     ]
  //   },
  //   {
  //     title: "Products",
  //     links: [
  //       { name: "Invoice Generator", path: "/invoice-generator" },
  //       { name: "Campaign Management", path: "/campaign-management" },
  //       { name: "Referral Program", path: "/referral-program" },
  //       { name: "CRM", path: "/crm" }
  //     ]
  //   },
  //   {
  //     title: "Solutions",
  //     links: [
  //       { name: "Email Marketing", path: "/email-marketing" },
  //       { name: "Campaign", path: "/campaign" },
  //       { name: "Mailing", path: "/mailing" },
  //       { name: "ERP", path: "/erp" }
  //     ]
  //   },
  //   {
  //     title: "Company",
  //     links: [
  //       { name: "About us", path: "/about" },
  //       { name: "Contact us", path: "/contact" },
  //       { name: "Team", path: "/team" },
  //       { name: "Blog", path: "/blog" },
  //       { name: "Careers", path: "/careers" }
  //     ]
  //   }
  // ];

  return (
     <footer className="footer">
      {/* <!-- <div className="container"> --> */}
        <div className="footer-top">
          <div className="container">
            <p>Get Connect With Us on Socials</p>
            <div className="social-icons">
              <img src="images/fb.png" alt="Facebook" />
              <img src="images/linkedin.png" alt="LinkedIn" />
              <img src="images/youtube.png" alt="YouTube" />
              <img src="images/instagram.png" alt="Instagram" />
            </div>
          </div>
        </div>
      <div className="container">

        <div className="footer-main">
          <div className="footer-logo">
            <img src="images/Logo2.png" alt="Sess Link" />
            <p>
              “With Sess, task and ticket workflows are more organized than
              ever. The intuitive dashboard keeps everyone on the same page.”
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Services</h4>
            <ul>
                  {/* <li>Form Builder</li> */}
                  <li> <a href="/templatebuilder">Template Builder  </a> </li>
                  {/* <li>Marketing Analytics</li>
                  <li>Email Tracking</li> */}
</ul>

            </div>

            <div className="footer-column">
              <h4>Products</h4>
              <ul>
                {/* <li>Invoice Generator</li> */}
                <li><a href="/campaign"> Campaign Management  </a></li>
                <li> <a href="/referral"> Referral Program </a></li>
                <li> <a href="/crm"> CRM </a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Solutions</h4>
              <ul>
                {/* <li>Email marketing</li> */}
                <li> <a href="/campaign"> Campaign </a></li>
                <li> <a href="/mailing"> Mailing </a></li>
                <li> <a href="/erp"> ERP </a> </li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                <li> <a href="/about"> About us </a></li>
                <li> <a href="/contact"> Contact us </a></li>
                 <li> <a href="/privacy-policy">Privacy and Policy </a></li>
                  <li> <a href="/terms-of-services">Terms Of Services </a></li>
                    <li> <a href="/user-data-deletion">User Data </a></li>
                      <li> <a href="https://support.sesslink.com/">Support</a></li>
                 
                 {/*
                {/* <li>Team</li>
                <li>Blog</li>
                <li>Careers</li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ margin: 0 }}>Copyright © 2025 Sess, Inc.</p>
          <p style={{ margin: 0 }}>
            Powered by <a href="https://edsytech.com/" target="_blank" rel="noopener noreferrer">Edsy Tech</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
